/**
 * Identity helpers shared across the dashboard.
 *
 * Used by the sidebar avatar, the share-card trader name default, and
 * anywhere else we need a friendly label for the signed-in user.
 */

/** Display label — name if present, otherwise the local-part of the email. */
export function displayName(
  name: string | null | undefined,
  email: string | undefined,
): string {
  if (name && name.trim()) return name;
  if (email) return email.split("@")[0] ?? email;
  return "User";
}

/** First character of the best available identity label, for avatar fallbacks. */
export function initialFor(
  name: string | null | undefined,
  email: string | undefined,
): string {
  const src = (name && name.trim()) || email || "U";
  return src.charAt(0).toUpperCase();
}
